// extracted by mini-css-extract-plugin
export default {"insta-auth":"l4-O-","insta":"e09Ff"};